// Library methods
import { useContext, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Grid from "@mui/material/Grid";
import ReportInfo from "./ReportInfo";
import SimultaneousResults from "./SimultaneousResults";
import FusionResults from "./FusionResults";
import StereopsisResults from "./StereopsisResults";
import EyeAlignmentResults from "./EyeAlignmentResults/EyeAlignmentResults";
import EyeReportContent from "../../../../components/UI/EyeReportContent";

// Utilities
import { ReportEachSectionContext } from "../../../../contexts/CommentContext";

const EyeReport = () => {
  // internationalization
  const { t } = useTranslation();
  const { examReport } = useContext(ReportEachSectionContext);

  const eyeAlignmentResults = useMemo(
    () => examReport?.postProcessing?.eyeAlignmentResults,
    [examReport?.postProcessing]
  );

  const simultaneousPerceptionResults = useMemo(
    () => examReport?.postProcessing?.simultaneousPerceptionResults,
    [examReport?.postProcessing]
  );

  const fusionResults = useMemo(
    () => examReport?.postProcessing?.fusionResults,
    [examReport?.postProcessing]
  );

  const stereopsisResults = useMemo(
    () => examReport?.postProcessing?.stereopsisResults,
    [examReport?.postProcessing]
  );

  const getFormattedResponse = useCallback(
    (responseData) => {
      // only return the option number
      if (responseData?.includes("Option")) {
        return responseData?.split("_")?.[1];
      }
      return t(`word_${responseData?.toLowerCase()}`);
    },
    [t]
  );

  if (!examReport) return null;

  // build the report content
  return (
    <div className="retinalogik-section retinalogik-report">
      <EyeReportContent
        ReportInfo={<ReportInfo />}
        ExamGraph={
          <Grid
            container
            item
            xs={12}
            display="flex"
            flexDirection="column"
            gap="20px"
          >
            {eyeAlignmentResults?.length > 0 && (
              <EyeAlignmentResults
                eyeAlignmentResults={eyeAlignmentResults}
                getFormattedResponse={getFormattedResponse}
              />
            )}

            <SimultaneousResults
              simultaneousPerceptionResults={simultaneousPerceptionResults}
            />

            {fusionResults?.length > 0 && (
              <FusionResults
                fusionResults={fusionResults}
                getFormattedResponse={getFormattedResponse}
              />
            )}

            {stereopsisResults?.length > 0 && (
              <StereopsisResults
                stereopsisResults={stereopsisResults}
                getFormattedResponse={getFormattedResponse}
              />
            )}
          </Grid>
        }
      />
    </div>
  );
};

export default EyeReport;
